<div class="page-section-container">
  <div class="page-section title primary-background">
    <title-small-section [titleSectionInformation]="titleSectionInformation"></title-small-section>
  </div>

  <div id="first-section" class="page-section">
    <div class="page-section-content">
      <div class="d-flex fd-col">
        <div class="lead pricing text-center">
          <span *ngFor="let group of productArray" class="material-icons border-circle lrg-icon slide-top">
            {{ group.icon }}
          </span>

          <h2>Find the right package to suit your needs.</h2>
          <p class="standard-text muted">
            Discounts for multi-product subscriptions and free {{ freeTrial }} day trial
          </p>
        </div>

        <div class="product-container d-flex jc-start ai-start fd-col--xs flex-wrap">
          <mat-card
            appearance="outlined"
            *ngFor="let group of productArray"
            class="text-center d-flex fd-col basis-30 basis-100--sm"
          >
            <mat-card-title>{{ group.name }}</mat-card-title>
            <br />
            <mat-card-subtitle>{{ group.description }}</mat-card-subtitle>
            <mat-card-content class="price-container">
              <div class="price">
                <span class="dollar-sign">$</span>
                <span class="cost-sign">{{ group.price }}</span>
                <span class="duration-sign">/ year</span>
              </div>
              <ng-container *ngIf="showSeats">
                <br />
                <p><strong>Additional Seats:</strong></p>
                <p>
                  Seat 2:
                  <strong>+$2,500</strong>
                </p>
                <p>
                  Seat 3:
                  <strong>+$2,325</strong>
                </p>
                <p>
                  Seat 4:
                  <strong>+$2,225</strong>
                </p>
                <p>
                  Seat 5:
                  <strong>+$2,125</strong>
                </p>
                <p>
                  Seat 6:
                  <strong>+$2,000</strong>
                </p>
              </ng-container>
              <br />
              <mat-checkbox [(ngModel)]="group.selected" (change)="calculatePrice()">Select product</mat-checkbox>
            </mat-card-content>
          </mat-card>
        </div>

        <mat-card appearance="outlined" class="pricing-summary-container d-flex fd-row flex-wrap">
          <div class="basis-50">
            <h4><strong>Subscription Pricing Summary</strong></h4>
          </div>
          <div class="basis-50 pricing-breakdown">
            <div>
              <div class="products" *ngIf="selectedProducts.length > 0">
                <ng-container *ngFor="let product of selectedProducts; let f = first; let c = count; let i = index">
                  <span *ngIf="!f && c > i">&nbsp;+&nbsp;</span>
                  <b class="standard-text summary" *ngIf="product.selected">{{ product.name }}</b>
                </ng-container>
              </div>
              <div class="products" *ngIf="selectedProducts.length == 0">
                <span class="standard-text summary select-text">Please select from the products above</span>
              </div>
              <div *ngIf="subTotalPrice > 0">
                <div class="standard-text summary subtotal">
                  Subtotal: {{ subTotalPrice | currency: 'USD' : 'symbol' : '1.0-2' }}
                </div>
                <div class="standard-text summary savings" *ngIf="percentDiscount !== 0">
                  <b>Savings: {{ subTotalPrice - totalPrice | currency: 'USD' : 'symbol' : '1.0-2' }}</b>
                </div>
                <div class="standard-text summary total">
                  Total: {{ totalPrice | currency: 'USD' : 'symbol' : '1.0-2' }}
                </div>
              </div>
            </div>
          </div>
          <div class="basis-100 d-flex fd-row jc-center ai-center">
            <button
              mat-raised-button
              routerLink="/register"
              class="free-trial-button"
              [ngStyle]="{ 'padding-top.px': totalPrice > 0 ? 0 : 20 }"
            >
              Try it for free
            </button>
          </div>
          <div class="basis-100 d-flex fd-row jc-center ai-center">
            <p class="try-it-caption">
              {{ freeTrial === 1 ? '1 day' : freeTrial + ' days' }} days trial. No credit card required.
            </p>
          </div>
        </mat-card>
      </div>
      <br />
      <br />
      <br />
      <div class="full-width align-center payment-options">
        <p>
          <strong>To discuss payment options,</strong>
          please contact
          <a href="mailto:jchalon@sbpub.com">jchalon&#64;sbpub.com</a>
          and supply your phone number and email address.
        </p>
      </div>
      <br />
      <br />
      <br />
    </div>
  </div>
</div>
